import { ROUTES } from '../routes';

/** The query parameter /profile reads for where to go once a display name is saved. */
export const THEN_PARAM = 'then';

/**
 * /profile, to choose a display name, and then on to `path` in this app: what the app does when the lobby refuses a
 * player with none (WH-155).
 */
export const displayNameDetour = (path: string): string =>
  `${ROUTES.profile}?${new URLSearchParams({ [THEN_PARAM]: path })}`;

/** Where /profile goes once a name is saved: `then`, if it is a path in this app; never another origin. */
export const thenPath = (search: string): string | undefined => {
  const then = new URLSearchParams(search).get(THEN_PARAM);

  return then?.startsWith('/') && !then.startsWith('//') && !then.includes('\\') ? then : undefined;
};
